import http from '../../http';

let wsBaseUrl = 'ws://supplier.craneweihua.com/supplier-resource/ws/msg/';

const state = {
    currentUser: {},
    stampUrl: '',
    currentVendor: {},
    isAdmin: false,
    isMain: false,
    role: 2,
    noReadMessageList: [],
    noticeList: [],
    orderCount: {
        noHandleQty: 0,
        finishQty: 0,
        reviewQty: 0
    },
    displayOrderDetailList: [],
    top: 10,
    ws: ''
};

const mutations = {
    SET_CUR_USER:(state, currentUser) => {
        state.role = currentUser.role;
        if(currentUser.role === 0) {
            state.isAdmin = true;
        } else if(currentUser.role === 1) {
            state.isMain = true;
        }
        if(currentUser.smallAvatar && currentUser.smallAvatar !== '') {
            currentUser.smallAvatar = 'data:image/jpg;base64,' + currentUser.smallAvatar;
        }
        state.currentUser =currentUser;
    },
    SET_NOTICE_LIST:(state, payload) => {
        state.noticeList = payload;
    },
    SET_NO_READ_MESSAGE_LIST:(state, payload) => {
        state.noReadMessageList = payload;
    },
    SET_MESSAGE_LIST:(state, payload) => {
        state.messageList = payload;
    },
    SET_CURRENT_VENDOR:(state, payload) => {
        state.currentVendor = payload;
        if (state.currentVendor && state.currentVendor.stamp) {
            state.stampUrl = 'data:image/jpg;base64,'+ state.currentVendor.stamp;
        }
    },
    SET_STAMP:(state, payload) => {
        state.stampUrl = payload;
    },
    SET_ORDER_COUNT:(state, payload) => {
        state.orderCount = payload;
    },
    SET_DISPLAY_ORDER_DETAIL_LIST: (state, payload) => {
        state.displayOrderDetailList = payload;
    }
};

const actions = {
    loadToken({commit}, loginUser){
        return new Promise((resolve) => {
            http.post('/supplier-auth/oauth/token', loginUser).then((res) => {
                resolve(res);
            }).catch((err) => {
                resolve(err.response);
            });
        });
    },
    loadUser({commit}) {
        return new Promise((resolve) => {
            http.post('/supplier-resource/system/user/get').then((res) => {
                if (res.status === 200) {
                    resolve(res);
                    commit('SET_CUR_USER',res.data.data);
                }
            });
        });
    },
    logout({commit}) {
        return new Promise((resolve) => {
            http.post('/supplier-auth/token/logout').then((res) => {
                resolve(res);
            });
        });
    },
    RefreshToken({commit}) {
        return new Promise((resolve, reject) => {
            let refreshToken = window.sessionStorage.getItem('wh-refresh-token');
            http.get('/supplier-auth/oauth/token', {grant_type: 'refresh_token',
                scope: 'user_info', refresh_token: refreshToken}).then((res) => {
                if (res.status === 200) {
                    resolve(res);
                }
            });
        });
    },
    getStamp({commit}) {
          http.post('/supplier-resource/system/vendor/getStamp').then((res) =>{
              if (res.status === 200) {
                  commit('SET_CURRENT_VENDOR', res.data.data);
              }
          })
    },
    getNoticeList({commit, state}) {
        return new Promise((resolve, reject) => {
            http.post('/supplier-resource/system/msg/noticeList'
                , {top: state.top})
                .then((res) => {
                    if (res.data.code === '200') {
                        commit('SET_NOTICE_LIST',res.data.data);
                        resolve(res.data);
                    }else {
                        resolve(res);
                    }
                });
        });

    },
    getNoReadMessageList({commit, state}) {
        return new Promise(((resolve, reject) => {
            http.post('/supplier-resource/system/msg/noReadMsg'
                , {userId: state.currentUser.id, vendorNo: state.currentUser.vendorNo})
                .then((res) => {
                    if (res.data.code === '200') {
                        commit('SET_NO_READ_MESSAGE_LIST',res.data.data);
                        resolve(res.data);
                    }else {
                        resolve(res);
                    }
                });
        }));
    },

    getCountOfSomeStatusX({commit}) {
        http.post('/supplier-resource/order/getCountOfSomeStatusX').then((res)=>{
            if(res.data.code === '200'){
                commit('SET_ORDER_COUNT', res.data.data);
            }
        })
    },

    listOrderDetailLimit({commit}, payload) {
        // payload: {statusX: xxx};
        http.post('/supplier-resource/order/listOrderDetailLimit', payload).then((res)=>{
            if(res.data.code ==='200'){
                commit('SET_DISPLAY_ORDER_DETAIL_LIST', res.data.data);
            }
        })
    },

    initWebSocket({state, dispatch, commit, rootState}) {
        // let ws;
        if ('WebSocket' in window) {
            state.ws = new WebSocket(wsBaseUrl + state.currentUser.id);
        }
        if ('MozWebSocket' in window) {
            state.ws = new MozWebSocket(wsBaseUrl +  state.currentUser.id);
        }
        state.ws.onmessage = function (evt) {
            if (evt.data === 'Notice') {
                dispatch('getNoticeList');
            }
            if (evt.data === 'Message') {
                dispatch('getNoReadMessageList');
                dispatch('msg/messageManagement/getMessageList', {currentUser: rootState.login.currentUser},{root: true});
            }
        };
    }
};

export  default {
    namespaced: true,
    state,
    mutations,
    actions
}